import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import Chip from '@mui/material/Chip';
import { Listing, ListingLegacy, SampleEstimatorListingTypes } from 'src/interfaces/idashboard';

import { POINTER_GREEN, amenitiesObject } from 'src/const';

const Ameneties = ({
  data,
  isMobileScreen,
  // estimatorSampleListingData,
}: {
  data: any[] | Listing;
  isMobileScreen: boolean;
  // estimatorSampleListingData?: SampleEstimatorListingTypes;
}) => {
  // const currentListingAmeneties = estimatorSampleListingData
  //   ? estimatorSampleListingData.amenities
  //   : data['amenities'];

    const currentListingAmeneties = data['amenities']

  return (
    <>
      <Typography color="textPrimary" variant="subtitle2" style={{ fontSize: '16px' }}>
        Ameneties <br />
        <Grid
          item
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          style={{ marginTop: isMobileScreen ? 0 : '10px' }}
          xs={12}
        >
          {Object.entries(amenitiesObject).map(([key, value], idx) => (
            <Grid item xs={3} spacing={2}>
              <Chip
                variant="outlined"
                color="success"
                size="small"
                label={value}
                key={'amm_list_' + idx}
                sx={{ width: '95%', marginBottom: '10px', color: POINTER_GREEN }}
                disabled={!currentListingAmeneties[key]}
              />
            </Grid>
          ))}
        </Grid>
      </Typography>
    </>
  );
};

export default Ameneties;
